export class MultiFiltroPrecioByrDto{
    codigosProductos: string[];
    codigosAeroplantas: string[];
    estados: number[];
    vigencias: number[];
    fechaVigencia: string;
    niveles: number[];
    loteId: string;
}
